// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.glass-panel {
    background:
      linear-gradient(180deg, rgba(255,255,255,0.5), rgba(255,255,255,0.22)),
      var(--bg-soft);
    border: 1px solid var(--line);
    box-shadow: var(--shadow-soft), inset 0 1px 0 rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(24px) saturate(160%);
    -webkit-backdrop-filter: blur(24px) saturate(160%);
  }
.glass-panel-strong {
    background:
      var(--surface-elevated),
      var(--bg-strong);
    border: 1px solid var(--line);
    box-shadow: var(--shadow-deep), inset 0 1px 0 rgba(255, 255, 255, 0.28);
    backdrop-filter: blur(32px) saturate(180%);
    -webkit-backdrop-filter: blur(32px) saturate(180%);
  }
.hero-glow {
    background: var(--hero);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.3),
      0 20px 60px rgba(15, 23, 42, 0.12);
  }
.interactive-card {
    transform: perspective(1200px) translateZ(0);
    transition:
      transform 0.32s ease,
      box-shadow 0.32s ease,
      border-color 0.32s ease,
      background 0.32s ease;
  }
.interactive-card:hover {
    transform: perspective(1200px) translateY(-8px) rotateX(1.2deg) rotateY(-1.2deg) scale(1.012);
    box-shadow: var(--shadow-deep), var(--glow);
  }
.floating-card {
    position: relative;
    overflow: hidden;
  }
.floating-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.18), transparent 38%, transparent 72%, rgba(255,255,255,0.08));
    pointer-events: none;
  }
.ripple-button {
    position: relative;
    overflow: hidden;
    will-change: transform;
  }
.ripple-button::after {
    content: '';
    position: absolute;
    width: 220px;
    height: 220px;
    left: 50%;
    top: 50%;
    border-radius: 9999px;
    transform: translate(-50%, -50%) scale(0);
    background: radial-gradient(circle, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0) 72%);
    transition: transform 0.48s ease;
    pointer-events: none;
  }
.ripple-button:hover::after {
    transform: translate(-50%, -50%) scale(1);
  }
.grid-noise {
    background-image:
      linear-gradient(rgba(148, 163, 184, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(148, 163, 184, 0.05) 1px, transparent 1px);
    background-size: 28px 28px;
  }
.soft-chip {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.36);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.5),
      0 10px 24px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
  }
.dark .soft-chip {
    background: rgba(10, 18, 32, 0.78);
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.05),
      0 16px 34px rgba(2, 8, 23, 0.28);
  }
.theme-input {
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    color: var(--text);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.18),
      0 10px 28px rgba(15, 23, 42, 0.06);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  }
.theme-input::-moz-placeholder {
    color: color-mix(in srgb, var(--muted) 78%, transparent);
  }
.theme-input::placeholder {
    color: color-mix(in srgb, var(--muted) 78%, transparent);
  }
.theme-input:focus {
    border-color: rgba(20, 184, 166, 0.56);
    box-shadow:
      0 0 0 4px rgba(20, 184, 166, 0.12),
      0 18px 42px rgba(20, 184, 166, 0.12);
    outline: none;
  }
.panel-subtle {
    background: var(--panel-subtle);
    border: 1px solid var(--line);
    color: var(--text);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
  }
.status-tint {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.7);
    color: var(--text);
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  }
.dark .status-tint {
    background: rgba(12, 22, 39, 0.76);
  }
.gradient-badge {
    background: var(--accent);
    color: white;
    box-shadow: var(--glow);
  }
.shimmer-card {
    position: relative;
    overflow: hidden;
  }
.shimmer-card::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(115deg, transparent 20%, rgba(255,255,255,0.28) 38%, transparent 56%);
    transform: translateX(-120%);
    animation: float-shimmer 2.2s ease-in-out infinite;
  }
.skeleton-shimmer {
    background:
      linear-gradient(120deg, rgba(255,255,255,0.05) 20%, rgba(255,255,255,0.4) 40%, rgba(255,255,255,0.05) 60%),
      rgba(148, 163, 184, 0.18);
    background-size: 220% 100%;
    animation: shimmer 1.5s linear infinite;
  }
.leaflet-div-icon-reset {
    background: transparent;
    border: 0;
  }
.leaflet-pin {
    border-radius: 9999px;
    border: 2px solid rgba(255,255,255,0.94);
    box-shadow: 0 0 0 10px rgba(15, 23, 42, 0.08), 0 10px 26px rgba(15, 23, 42, 0.18);
  }
.leaflet-pin-donor {
    width: 18px;
    height: 18px;
    background: linear-gradient(135deg, #22c55e, #14b8a6);
  }
.leaflet-pin-ngo {
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, #0ea5e9, #38bdf8);
    animation: pulse-marker 2s ease-in-out infinite;
  }
.leaflet-pin-selected {
    width: 22px;
    height: 22px;
    background: linear-gradient(135deg, #f97316, #fb7185);
    animation: pulse-marker 1.8s ease-in-out infinite;
  }
.leaflet-driver-marker {
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 9999px;
    border: 2px solid rgba(255,255,255,0.96);
    background: linear-gradient(135deg, #14b8a6, #38bdf8);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    box-shadow:
      0 0 0 10px rgba(20, 184, 166, 0.14),
      0 12px 26px rgba(14, 165, 233, 0.22);
  }
.leaflet-driver-marker::before {
    content: '';
    position: absolute;
    inset: -7px;
    border-radius: 9999px;
    background: rgba(14, 165, 233, 0.18);
    animation: pulse-marker 1.6s ease-in-out infinite;
    z-index: -1;
  }
.dark .leaflet-popup-content-wrapper,
  .dark .leaflet-popup-tip {
    background: rgba(10, 18, 32, 0.88);
    color: #f4f7fb;
  }
.dark .leaflet-control-zoom a {
    color: #f8fafc;
    background: rgba(10, 18, 32, 0.95);
  }
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-3{
  left: 0.75rem;
  right: 0.75rem;
}
.inset-x-5{
  left: 1.25rem;
  right: 1.25rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.left-5{
  left: 1.25rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.block{
  display: block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[560px\\]{
  height: 560px;
}
.h-full{
  height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-10{
  width: 2.5rem;
}
.w-14{
  width: 3.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-7{
  width: 1.75rem;
}
.w-9{
  width: 2.25rem;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1500px\\]{
  max-width: 1500px;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1 0%;
}
.shrink-0{
  flex-shrink: 0;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-hidden{
  overflow: hidden;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[1\\.5rem\\]{
  border-radius: 1.5rem;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[22px\\]{
  border-radius: 22px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[26px\\]{
  border-radius: 26px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[2rem\\]{
  border-radius: 2rem;
}
.rounded-\\[30px\\]{
  border-radius: 30px;
}
.rounded-\\[32px\\]{
  border-radius: 32px;
}
.rounded-\\[34px\\]{
  border-radius: 34px;
}
.rounded-\\[36px\\]{
  border-radius: 36px;
}
.rounded-\\[38px\\]{
  border-radius: 38px;
}
.rounded-\\[40px\\]{
  border-radius: 40px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300\\/60{
  border-color: rgb(110 231 183 / 0.6);
}
.border-emerald-300\\/70{
  border-color: rgb(110 231 183 / 0.7);
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-300\\/60{
  border-color: rgb(253 164 175 / 0.6);
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/55{
  border-color: rgb(255 255 255 / 0.55);
}
.bg-\\[radial-gradient\\(circle_at_20\\%_30\\%\\2c rgba\\(249\\2c 115\\2c 22\\2c 0\\.25\\)\\2c transparent_18\\%\\)\\2c radial-gradient\\(circle_at_60\\%_55\\%\\2c rgba\\(14\\2c 165\\2c 233\\2c 0\\.25\\)\\2c transparent_20\\%\\)\\2c radial-gradient\\(circle_at_78\\%_25\\%\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.22\\)\\2c transparent_18\\%\\)\\2c \\#f8fafc\\]{
  background-color: radial-gradient(circle at 20% 30%,rgba(249,115,22,0.25),transparent 18%),radial-gradient(circle at 60% 55%,rgba(14,165,233,0.25),transparent 20%),radial-gradient(circle at 78% 25%,rgba(16,185,129,0.22),transparent 18%),#f8fafc;
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-clay{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/20{
  background-color: rgb(52 211 153 / 0.2);
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-ink{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pine{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/90{
  background-color: rgb(241 245 249 / 0.9);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-\\[image\\:var\\(--accent\\)\\]{
  background-image: var(--accent);
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.18\\)\\2c rgba\\(56\\2c 189\\2c 248\\2c 0\\.16\\)\\)\\]{
  background-image: linear-gradient(135deg,rgba(16,185,129,0.18),rgba(56,189,248,0.16));
}
.bg-\\[linear-gradient\\(145deg\\2c rgba\\(255\\2c 251\\2c 247\\2c 0\\.98\\)\\2c rgba\\(245\\2c 248\\2c 255\\2c 0\\.96\\)_38\\%\\2c rgba\\(236\\2c 253\\2c 245\\2c 0\\.94\\)_70\\%\\2c rgba\\(255\\2c 237\\2c 213\\2c 0\\.98\\)\\)\\]{
  background-image: linear-gradient(145deg,rgba(255,251,247,0.98),rgba(245,248,255,0.96) 38%,rgba(236,253,245,0.94) 70%,rgba(255,237,213,0.98));
}
.bg-\\[radial-gradient\\(circle_at_top_left\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.92\\)\\2c transparent_34\\%\\)\\2c radial-gradient\\(circle_at_bottom_right\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.14\\)\\2c transparent_24\\%\\)\\2c linear-gradient\\(transparent_96\\%\\2c rgba\\(148\\2c 163\\2c 184\\2c 0\\.08\\)_100\\%\\)\\]{
  background-image: radial-gradient(circle at top left,rgba(255,255,255,0.92),transparent 34%),radial-gradient(circle at bottom right,rgba(16,185,129,0.14),transparent 24%),linear-gradient(transparent 96%,rgba(148,163,184,0.08) 100%);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400{
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/20{
  --tw-gradient-from: rgb(34 197 94 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ink{
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-emerald-500{
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-800{
  --tw-gradient-to: rgb(30 41 59 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e293b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500{
  --tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14b8a6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-orange-50{
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-500\\/20{
  --tw-gradient-to: rgb(249 115 22 / 0.2) var(--tw-gradient-to-position);
}
.to-pine{
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}
.to-sky-500{
  --tw-gradient-to: #0ea5e9 var(--tw-gradient-to-position);
}
.to-slate-700{
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.to-teal-300{
  --tw-gradient-to: #5eead4 var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-500\\/20{
  --tw-gradient-to: rgb(20 184 166 / 0.2) var(--tw-gradient-to-position);
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pt-4{
  padding-top: 1rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.font-\\[\\'Poppins\\'\\2c sans-serif\\]{
  font-family: 'Poppins',sans-serif;
}
.font-display{
  font-family: Poppins, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[2rem\\]{
  font-size: 2rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.04em\\]{
  letter-spacing: -0.04em;
}
.tracking-\\[-0\\.05em\\]{
  letter-spacing: -0.05em;
}
.tracking-\\[-0\\.06em\\]{
  letter-spacing: -0.06em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.34em\\]{
  letter-spacing: 0.34em;
}
.tracking-\\[0\\.35em\\]{
  letter-spacing: 0.35em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.text-\\[color\\:var\\(--muted\\)\\]{
  color: var(--muted);
}
.text-\\[color\\:var\\(--text\\)\\]{
  color: var(--text);
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-clay{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-emerald-100{
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-orange-300{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-orange-950{
  --tw-text-opacity: 1;
  color: rgb(67 20 7 / var(--tw-text-opacity, 1));
}
.text-pine{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-950{
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity, 1));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-950{
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-700\\/85{
  color: rgb(51 65 85 / 0.85);
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-slate-950{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-40{
  opacity: 0.4;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_22px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 10px 22px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 10px 22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 10px 24px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.45\\)\\2c 0_12px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.45),0 12px 24px rgba(15,23,42,0.08);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[var\\(--glow\\)\\]{
  --tw-shadow-color: var(--glow);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-deep\\)\\]{
  --tw-shadow-color: var(--shadow-deep);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-soft\\)\\]{
  --tw-shadow-color: var(--shadow-soft);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-300\\/20{
  --tw-shadow-color: rgb(253 186 116 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-700{
  transition-duration: 700ms;
}
.\\[background-image\\:linear-gradient\\(rgba\\(148\\2c 163\\2c 184\\2c 0\\.08\\)_1px\\2c transparent_1px\\)\\2c linear-gradient\\(90deg\\2c rgba\\(148\\2c 163\\2c 184\\2c 0\\.08\\)_1px\\2c transparent_1px\\)\\]{
  background-image: linear-gradient(rgba(148,163,184,0.08) 1px,transparent 1px),linear-gradient(90deg,rgba(148,163,184,0.08) 1px,transparent 1px);
}
.\\[background-size\\:32px_32px\\]{
  background-size: 32px 32px;
}

:root {
  color-scheme: light;
  --bg: #f7f8fc;
  --bg-soft: rgba(255, 255, 255, 0.74);
  --bg-strong: rgba(255, 255, 255, 0.88);
  --text: #111827;
  --muted: #546174;
  --line: rgba(148, 163, 184, 0.2);
  --shadow-soft: 0 18px 50px rgba(15, 23, 42, 0.08);
  --shadow-deep: 0 36px 100px rgba(15, 23, 42, 0.14);
  --hero: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(239, 248, 255, 0.82) 35%, rgba(236, 253, 245, 0.82) 72%, rgba(255, 237, 213, 0.9));
  --panel-tint: linear-gradient(180deg, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.34));
  --accent: linear-gradient(135deg, #10b981 0%, #14b8a6 48%, #38bdf8 100%);
  --accent-warm: linear-gradient(135deg, #f97316 0%, #fb7185 50%, #ef4444 100%);
  --accent-soft: rgba(16, 185, 129, 0.16);
  --glow: 0 18px 50px rgba(20, 184, 166, 0.2);
  --input-bg: rgba(255, 255, 255, 0.84);
  --input-border: rgba(148, 163, 184, 0.28);
  --panel-subtle: rgba(255, 255, 255, 0.64);
  --surface-elevated: linear-gradient(180deg, rgba(255, 255, 255, 0.78), rgba(255, 255, 255, 0.5));
}

.dark {
  color-scheme: dark;
  --bg: #08111f;
  --bg-soft: rgba(12, 22, 39, 0.76);
  --bg-strong: rgba(10, 18, 32, 0.92);
  --text: #f8fafc;
  --muted: #9fb0c7;
  --line: rgba(148, 163, 184, 0.14);
  --shadow-soft: 0 22px 64px rgba(2, 8, 23, 0.42);
  --shadow-deep: 0 44px 120px rgba(2, 8, 23, 0.62);
  --hero: linear-gradient(145deg, rgba(10, 18, 32, 0.96), rgba(15, 23, 42, 0.9) 40%, rgba(17, 94, 89, 0.42) 72%, rgba(244, 114, 182, 0.12));
  --panel-tint: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  --accent: linear-gradient(135deg, #10b981 0%, #14b8a6 55%, #38bdf8 100%);
  --accent-warm: linear-gradient(135deg, #f97316 0%, #ef4444 52%, #fb7185 100%);
  --accent-soft: rgba(20, 184, 166, 0.15);
  --glow: 0 22px 58px rgba(20, 184, 166, 0.18);
  --input-bg: rgba(9, 17, 31, 0.9);
  --input-border: rgba(148, 163, 184, 0.2);
  --panel-subtle: rgba(15, 23, 42, 0.62);
  --surface-elevated: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  min-height: 100vh;
  font-family: Inter, sans-serif;
  color: var(--text);
  background:
    radial-gradient(circle at 10% 12%, rgba(251, 146, 60, 0.12), transparent 26%),
    radial-gradient(circle at 88% 14%, rgba(56, 189, 248, 0.12), transparent 24%),
    radial-gradient(circle at 82% 84%, rgba(45, 212, 191, 0.14), transparent 20%),
    radial-gradient(circle at 18% 82%, rgba(251, 113, 133, 0.08), transparent 24%),
    linear-gradient(180deg, rgba(255,255,255,0.58), rgba(255,255,255,0.22)),
    var(--bg);
}

.dark body {
  background:
    radial-gradient(circle at 12% 12%, rgba(249, 115, 22, 0.1), transparent 22%),
    radial-gradient(circle at 84% 14%, rgba(20, 184, 166, 0.14), transparent 20%),
    radial-gradient(circle at 80% 82%, rgba(56, 189, 248, 0.1), transparent 18%),
    radial-gradient(circle at 18% 80%, rgba(244, 114, 182, 0.08), transparent 24%),
    linear-gradient(180deg, rgba(8,17,31,0.82), rgba(8,17,31,0.96)),
    var(--bg);
}

input,
select,
textarea,
button {
  color: inherit;
  font: inherit;
}

#root {
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

::-moz-selection {
  background: rgba(20, 184, 166, 0.24);
}

::selection {
  background: rgba(20, 184, 166, 0.24);
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

@keyframes pulse-marker {
  0%, 100% {
    transform: scale(1);
    opacity: 0.96;
  }

  50% {
    transform: scale(1.14);
    opacity: 0.54;
  }
}

@keyframes float-shimmer {
  0% {
    transform: translateX(-120%);
  }

  55%,
  100% {
    transform: translateX(140%);
  }
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:text-\\[color\\:var\\(--text\\)\\]:hover{
  color: var(--text);
}

.hover\\:shadow-\\[var\\(--shadow-soft\\)\\]:hover{
  --tw-shadow-color: var(--shadow-soft);
  --tw-shadow: var(--tw-shadow-colored);
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

@media (min-width: 640px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }
}

@media (min-width: 768px){

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:min-w-\\[320px\\]{
    min-width: 320px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-\\[2\\.1rem\\]{
    font-size: 2.1rem;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[0\\.82fr\\2c 1\\.18fr\\]{
    grid-template-columns: 0.82fr 1.18fr;
  }

  .lg\\:grid-cols-\\[0\\.94fr\\2c 1\\.06fr\\]{
    grid-template-columns: 0.94fr 1.06fr;
  }

  .lg\\:grid-cols-\\[0\\.95fr\\2c 1\\.05fr\\]{
    grid-template-columns: 0.95fr 1.05fr;
  }

  .lg\\:grid-cols-\\[1\\.05fr\\2c 0\\.95fr\\]{
    grid-template-columns: 1.05fr 0.95fr;
  }

  .lg\\:grid-cols-\\[1\\.15fr\\2c 0\\.85fr\\]{
    grid-template-columns: 1.15fr 0.85fr;
  }

  .lg\\:grid-cols-\\[1\\.1fr\\2c 0\\.9fr\\]{
    grid-template-columns: 1.1fr 0.9fr;
  }

  .lg\\:grid-cols-\\[1\\.2fr\\2c 0\\.8fr\\]{
    grid-template-columns: 1.2fr 0.8fr;
  }

  .lg\\:grid-cols-\\[1fr\\2c 0\\.92fr\\]{
    grid-template-columns: 1fr 0.92fr;
  }

  .lg\\:grid-cols-\\[260px\\2c minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 260px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1fr);
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1280px){

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1\\.15fr\\2c 0\\.85fr\\]{
    grid-template-columns: 1.15fr 0.85fr;
  }

  .xl\\:grid-cols-\\[1fr\\2c 1fr\\]{
    grid-template-columns: 1fr 1fr;
  }
}

@media (prefers-color-scheme: dark){

  .dark\\:border-emerald-500\\/20{
    border-color: rgb(16 185 129 / 0.2);
  }

  .dark\\:border-orange-500\\/20{
    border-color: rgb(249 115 22 / 0.2);
  }

  .dark\\:border-transparent{
    border-color: transparent;
  }

  .dark\\:border-white\\/10{
    border-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:bg-\\[radial-gradient\\(circle_at_20\\%_30\\%\\2c rgba\\(249\\2c 115\\2c 22\\2c 0\\.25\\)\\2c transparent_18\\%\\)\\2c radial-gradient\\(circle_at_60\\%_55\\%\\2c rgba\\(14\\2c 165\\2c 233\\2c 0\\.25\\)\\2c transparent_20\\%\\)\\2c radial-gradient\\(circle_at_78\\%_25\\%\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.22\\)\\2c transparent_18\\%\\)\\2c \\#0f172a\\]{
    background-color: radial-gradient(circle at 20% 30%,rgba(249,115,22,0.25),transparent 18%),radial-gradient(circle at 60% 55%,rgba(14,165,233,0.25),transparent 20%),radial-gradient(circle at 78% 25%,rgba(16,185,129,0.22),transparent 18%),#0f172a;
  }

  .dark\\:bg-amber-500\\/10{
    background-color: rgb(245 158 11 / 0.1);
  }

  .dark\\:bg-emerald-500\\/10{
    background-color: rgb(16 185 129 / 0.1);
  }

  .dark\\:bg-emerald-500\\/15{
    background-color: rgb(16 185 129 / 0.15);
  }

  .dark\\:bg-orange-500\\/10{
    background-color: rgb(249 115 22 / 0.1);
  }

  .dark\\:bg-orange-500\\/15{
    background-color: rgb(249 115 22 / 0.15);
  }

  .dark\\:bg-rose-500\\/10{
    background-color: rgb(244 63 94 / 0.1);
  }

  .dark\\:bg-rose-500\\/15{
    background-color: rgb(244 63 94 / 0.15);
  }

  .dark\\:bg-sky-500\\/10{
    background-color: rgb(14 165 233 / 0.1);
  }

  .dark\\:bg-sky-500\\/15{
    background-color: rgb(14 165 233 / 0.15);
  }

  .dark\\:bg-slate-600{
    --tw-bg-opacity: 1;
    background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-slate-900\\/20{
    background-color: rgb(15 23 42 / 0.2);
  }

  .dark\\:bg-slate-900\\/35{
    background-color: rgb(15 23 42 / 0.35);
  }

  .dark\\:bg-violet-500\\/15{
    background-color: rgb(139 92 246 / 0.15);
  }

  .dark\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-white\\/10{
    background-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:bg-white\\/5{
    background-color: rgb(255 255 255 / 0.05);
  }

  .dark\\:bg-\\[linear-gradient\\(135deg\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.22\\)\\2c rgba\\(56\\2c 189\\2c 248\\2c 0\\.18\\)\\)\\]{
    background-image: linear-gradient(135deg,rgba(16,185,129,0.22),rgba(56,189,248,0.18));
  }

  .dark\\:bg-\\[linear-gradient\\(145deg\\2c rgba\\(8\\2c 17\\2c 31\\2c 0\\.98\\)\\2c rgba\\(15\\2c 23\\2c 42\\2c 0\\.94\\)_44\\%\\2c rgba\\(13\\2c 148\\2c 136\\2c 0\\.2\\)_78\\%\\2c rgba\\(251\\2c 113\\2c 133\\2c 0\\.08\\)\\)\\]{
    background-image: linear-gradient(145deg,rgba(8,17,31,0.98),rgba(15,23,42,0.94) 44%,rgba(13,148,136,0.2) 78%,rgba(251,113,133,0.08));
  }

  .dark\\:bg-\\[radial-gradient\\(circle_at_top_left\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.08\\)\\2c transparent_30\\%\\)\\2c radial-gradient\\(circle_at_bottom_right\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.12\\)\\2c transparent_24\\%\\)\\]{
    background-image: radial-gradient(circle at top left,rgba(255,255,255,0.08),transparent 30%),radial-gradient(circle at bottom right,rgba(16,185,129,0.12),transparent 24%);
  }

  .dark\\:from-emerald-500\\/10{
    --tw-gradient-from: rgb(16 185 129 / 0.1) var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  }

  .dark\\:via-slate-900\\/60{
    --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }

  .dark\\:to-orange-500\\/10{
    --tw-gradient-to: rgb(249 115 22 / 0.1) var(--tw-gradient-to-position);
  }

  .dark\\:text-amber-200{
    --tw-text-opacity: 1;
    color: rgb(253 230 138 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-cyan-300{
    --tw-text-opacity: 1;
    color: rgb(103 232 249 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-emerald-200{
    --tw-text-opacity: 1;
    color: rgb(167 243 208 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-emerald-300{
    --tw-text-opacity: 1;
    color: rgb(110 231 183 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-orange-200{
    --tw-text-opacity: 1;
    color: rgb(254 215 170 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-orange-300{
    --tw-text-opacity: 1;
    color: rgb(253 186 116 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-rose-100{
    --tw-text-opacity: 1;
    color: rgb(255 228 230 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-rose-200{
    --tw-text-opacity: 1;
    color: rgb(254 205 211 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-rose-300{
    --tw-text-opacity: 1;
    color: rgb(253 164 175 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-sky-100{
    --tw-text-opacity: 1;
    color: rgb(224 242 254 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-sky-200{
    --tw-text-opacity: 1;
    color: rgb(186 230 253 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-sky-300{
    --tw-text-opacity: 1;
    color: rgb(125 211 252 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-100{
    --tw-text-opacity: 1;
    color: rgb(241 245 249 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-200{
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-300{
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-400{
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-50{
    --tw-text-opacity: 1;
    color: rgb(248 250 252 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-slate-900{
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-violet-200{
    --tw-text-opacity: 1;
    color: rgb(221 214 254 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-violet-300{
    --tw-text-opacity: 1;
    color: rgb(196 181 253 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }

  .dark\\:opacity-10{
    opacity: 0.1;
  }

  .dark\\:shadow-emerald-500\\/20{
    --tw-shadow-color: rgb(16 185 129 / 0.2);
    --tw-shadow: var(--tw-shadow-colored);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AAiGZ;IACE;;oBAEgB;IAChB,6BAA6B;IAC7B,uEAAuE;IACvE,0CAA0C;IAC1C,kDAAkD;EACpD;AAEA;IACE;;sBAEkB;IAClB,6BAA6B;IAC7B,uEAAuE;IACvE,0CAA0C;IAC1C,kDAAkD;EACpD;AAEA;IACE,uBAAuB;IACvB;;wCAEoC;EACtC;AAEA;IACE,4CAA4C;IAC5C;;;;2BAIuB;EACzB;AAEA;IACE,6FAA6F;IAC7F,2CAA2C;EAC7C;AAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qHAAqH;IACrH,oBAAoB;EACtB;AAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,yCAAyC;IACzC,6FAA6F;IAC7F,gCAAgC;IAChC,oBAAoB;EACtB;AAEA;IACE,yCAAyC;EAC3C;AAEA;IACE;;4EAEwE;IACxE,0BAA0B;EAC5B;AAEA;IACE,oCAAoC;IACpC,2CAA2C;IAC3C;;wCAEoC;IACpC,2BAA2B;IAC3B,mCAAmC;EACrC;AAEA;IACE,kCAAkC;IAClC,uCAAuC;IACvC;;sCAEkC;EACpC;AAEA;IACE,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB;;wCAEoC;IACpC,2BAA2B;IAC3B,mCAAmC;EACrC;AAEA;IACE,wDAAwD;EAC1D;AAFA;IACE,wDAAwD;EAC1D;AAEA;IACE,sCAAsC;IACtC;;0CAEsC;IACtC,aAAa;EACf;AAEA;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;EACrC;AAEA;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,8CAA8C;IAC9C,2BAA2B;IAC3B,mCAAmC;EACrC;AAEA;IACE,kCAAkC;EACpC;AAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;EACzB;AAQA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,iGAAiG;IACjG,4BAA4B;IAC5B,kDAAkD;EACpD;AAEA;IACE;;+BAE2B;IAC3B,0BAA0B;IAC1B,uCAAuC;EACzC;AAEA;IACE,uBAAuB;IACvB,SAAS;EACX;AAEA;IACE,qBAAqB;IACrB,wCAAwC;IACxC,iFAAiF;EACnF;AAEA;IACE,WAAW;IACX,YAAY;IACZ,qDAAqD;EACvD;AAEA;IACE,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,+CAA+C;EACjD;AAEA;IACE,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,iDAAiD;EACnD;AAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wCAAwC;IACxC,qDAAqD;IACrD,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB;;0CAEsC;EACxC;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,oCAAoC;IACpC,iDAAiD;IACjD,WAAW;EACb;AAiBA;;IAEE,kCAAkC;IAClC,cAAc;EAChB;AAOA;IACE,cAAc;IACd,kCAAkC;EACpC;AA5WF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iDAAiD;EACjD,kDAAkD;EAClD,iJAAiJ;EACjJ,2FAA2F;EAC3F,wEAAwE;EACxE,6EAA6E;EAC7E,uCAAuC;EACvC,2CAA2C;EAC3C,qCAAqC;EACrC,yCAAyC;EACzC,yCAAyC;EACzC,gGAAgG;AAClG;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;EAChD,yIAAyI;EACzI,2FAA2F;EAC3F,wEAAwE;EACxE,6EAA6E;EAC7E,uCAAuC;EACvC,4CAA4C;EAC5C,gCAAgC;EAChC,wCAAwC;EACxC,sCAAsC;EACtC,iGAAiG;AACnG;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB;;;;;;aAMW;AACb;;AAEA;EACE;;;;;;aAMW;AACb;;AAEA;;;;EAIE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAFA;EACE,oCAAoC;AACtC;;AAmRA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAlZA;EAAA,2BAmZA;EAnZA;AAmZA;;AAnZA;EAAA,0BAmZA;EAnZA;AAmZA;;AAnZA;EAAA,kBAmZA;EAnZA,kBAmZA;EAnZA;AAmZA;;AAnZA;EAAA;AAmZA;;AAnZA;EAAA,qCAmZA;EAnZA;AAmZA;;AAnZA;EAAA;AAmZA;;AAnZA;;EAAA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;AAAA;;AAnZA;;EAAA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,qBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,iBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,eAmZA;IAnZA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,iBAmZA;IAnZA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,eAmZA;IAnZA;EAmZA;;EAnZA;IAAA,mBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;AAAA;;AAnZA;;EAAA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;AAAA;;AAnZA;;EAAA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;AAAA;;AAnZA;;EAAA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,kBAmZA;IAnZA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,0EAmZA;IAnZA,oEAmZA;IAnZA;EAmZA;;EAnZA;IAAA,mEAmZA;IAnZA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA,oBAmZA;IAnZA;EAmZA;;EAnZA;IAAA;EAmZA;;EAnZA;IAAA,wCAmZA;IAnZA;EAmZA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  color-scheme: light;\n  --bg: #f7f8fc;\n  --bg-soft: rgba(255, 255, 255, 0.74);\n  --bg-strong: rgba(255, 255, 255, 0.88);\n  --text: #111827;\n  --muted: #546174;\n  --line: rgba(148, 163, 184, 0.2);\n  --shadow-soft: 0 18px 50px rgba(15, 23, 42, 0.08);\n  --shadow-deep: 0 36px 100px rgba(15, 23, 42, 0.14);\n  --hero: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(239, 248, 255, 0.82) 35%, rgba(236, 253, 245, 0.82) 72%, rgba(255, 237, 213, 0.9));\n  --panel-tint: linear-gradient(180deg, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.34));\n  --accent: linear-gradient(135deg, #10b981 0%, #14b8a6 48%, #38bdf8 100%);\n  --accent-warm: linear-gradient(135deg, #f97316 0%, #fb7185 50%, #ef4444 100%);\n  --accent-soft: rgba(16, 185, 129, 0.16);\n  --glow: 0 18px 50px rgba(20, 184, 166, 0.2);\n  --input-bg: rgba(255, 255, 255, 0.84);\n  --input-border: rgba(148, 163, 184, 0.28);\n  --panel-subtle: rgba(255, 255, 255, 0.64);\n  --surface-elevated: linear-gradient(180deg, rgba(255, 255, 255, 0.78), rgba(255, 255, 255, 0.5));\n}\n\n.dark {\n  color-scheme: dark;\n  --bg: #08111f;\n  --bg-soft: rgba(12, 22, 39, 0.76);\n  --bg-strong: rgba(10, 18, 32, 0.92);\n  --text: #f8fafc;\n  --muted: #9fb0c7;\n  --line: rgba(148, 163, 184, 0.14);\n  --shadow-soft: 0 22px 64px rgba(2, 8, 23, 0.42);\n  --shadow-deep: 0 44px 120px rgba(2, 8, 23, 0.62);\n  --hero: linear-gradient(145deg, rgba(10, 18, 32, 0.96), rgba(15, 23, 42, 0.9) 40%, rgba(17, 94, 89, 0.42) 72%, rgba(244, 114, 182, 0.12));\n  --panel-tint: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));\n  --accent: linear-gradient(135deg, #10b981 0%, #14b8a6 55%, #38bdf8 100%);\n  --accent-warm: linear-gradient(135deg, #f97316 0%, #ef4444 52%, #fb7185 100%);\n  --accent-soft: rgba(20, 184, 166, 0.15);\n  --glow: 0 22px 58px rgba(20, 184, 166, 0.18);\n  --input-bg: rgba(9, 17, 31, 0.9);\n  --input-border: rgba(148, 163, 184, 0.2);\n  --panel-subtle: rgba(15, 23, 42, 0.62);\n  --surface-elevated: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  font-family: Inter, sans-serif;\n  color: var(--text);\n  background:\n    radial-gradient(circle at 10% 12%, rgba(251, 146, 60, 0.12), transparent 26%),\n    radial-gradient(circle at 88% 14%, rgba(56, 189, 248, 0.12), transparent 24%),\n    radial-gradient(circle at 82% 84%, rgba(45, 212, 191, 0.14), transparent 20%),\n    radial-gradient(circle at 18% 82%, rgba(251, 113, 133, 0.08), transparent 24%),\n    linear-gradient(180deg, rgba(255,255,255,0.58), rgba(255,255,255,0.22)),\n    var(--bg);\n}\n\n.dark body {\n  background:\n    radial-gradient(circle at 12% 12%, rgba(249, 115, 22, 0.1), transparent 22%),\n    radial-gradient(circle at 84% 14%, rgba(20, 184, 166, 0.14), transparent 20%),\n    radial-gradient(circle at 80% 82%, rgba(56, 189, 248, 0.1), transparent 18%),\n    radial-gradient(circle at 18% 80%, rgba(244, 114, 182, 0.08), transparent 24%),\n    linear-gradient(180deg, rgba(8,17,31,0.82), rgba(8,17,31,0.96)),\n    var(--bg);\n}\n\ninput,\nselect,\ntextarea,\nbutton {\n  color: inherit;\n  font: inherit;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n::selection {\n  background: rgba(20, 184, 166, 0.24);\n}\n\n@layer components {\n  .glass-panel {\n    background:\n      linear-gradient(180deg, rgba(255,255,255,0.5), rgba(255,255,255,0.22)),\n      var(--bg-soft);\n    border: 1px solid var(--line);\n    box-shadow: var(--shadow-soft), inset 0 1px 0 rgba(255, 255, 255, 0.35);\n    backdrop-filter: blur(24px) saturate(160%);\n    -webkit-backdrop-filter: blur(24px) saturate(160%);\n  }\n\n  .glass-panel-strong {\n    background:\n      var(--surface-elevated),\n      var(--bg-strong);\n    border: 1px solid var(--line);\n    box-shadow: var(--shadow-deep), inset 0 1px 0 rgba(255, 255, 255, 0.28);\n    backdrop-filter: blur(32px) saturate(180%);\n    -webkit-backdrop-filter: blur(32px) saturate(180%);\n  }\n\n  .hero-glow {\n    background: var(--hero);\n    box-shadow:\n      inset 0 1px 0 rgba(255, 255, 255, 0.3),\n      0 20px 60px rgba(15, 23, 42, 0.12);\n  }\n\n  .interactive-card {\n    transform: perspective(1200px) translateZ(0);\n    transition:\n      transform 0.32s ease,\n      box-shadow 0.32s ease,\n      border-color 0.32s ease,\n      background 0.32s ease;\n  }\n\n  .interactive-card:hover {\n    transform: perspective(1200px) translateY(-8px) rotateX(1.2deg) rotateY(-1.2deg) scale(1.012);\n    box-shadow: var(--shadow-deep), var(--glow);\n  }\n\n  .floating-card {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .floating-card::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(255,255,255,0.18), transparent 38%, transparent 72%, rgba(255,255,255,0.08));\n    pointer-events: none;\n  }\n\n  .ripple-button {\n    position: relative;\n    overflow: hidden;\n    will-change: transform;\n  }\n\n  .ripple-button::after {\n    content: '';\n    position: absolute;\n    width: 220px;\n    height: 220px;\n    left: 50%;\n    top: 50%;\n    border-radius: 9999px;\n    transform: translate(-50%, -50%) scale(0);\n    background: radial-gradient(circle, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0) 72%);\n    transition: transform 0.48s ease;\n    pointer-events: none;\n  }\n\n  .ripple-button:hover::after {\n    transform: translate(-50%, -50%) scale(1);\n  }\n\n  .grid-noise {\n    background-image:\n      linear-gradient(rgba(148, 163, 184, 0.05) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(148, 163, 184, 0.05) 1px, transparent 1px);\n    background-size: 28px 28px;\n  }\n\n  .soft-chip {\n    background: rgba(255, 255, 255, 0.7);\n    border: 1px solid rgba(255, 255, 255, 0.36);\n    box-shadow:\n      inset 0 1px 0 rgba(255, 255, 255, 0.5),\n      0 10px 24px rgba(15, 23, 42, 0.08);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n  }\n\n  .dark .soft-chip {\n    background: rgba(10, 18, 32, 0.78);\n    border-color: rgba(255, 255, 255, 0.08);\n    box-shadow:\n      inset 0 1px 0 rgba(255, 255, 255, 0.05),\n      0 16px 34px rgba(2, 8, 23, 0.28);\n  }\n\n  .theme-input {\n    background: var(--input-bg);\n    border: 1px solid var(--input-border);\n    color: var(--text);\n    box-shadow:\n      inset 0 1px 0 rgba(255, 255, 255, 0.18),\n      0 10px 28px rgba(15, 23, 42, 0.06);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n  }\n\n  .theme-input::placeholder {\n    color: color-mix(in srgb, var(--muted) 78%, transparent);\n  }\n\n  .theme-input:focus {\n    border-color: rgba(20, 184, 166, 0.56);\n    box-shadow:\n      0 0 0 4px rgba(20, 184, 166, 0.12),\n      0 18px 42px rgba(20, 184, 166, 0.12);\n    outline: none;\n  }\n\n  .panel-subtle {\n    background: var(--panel-subtle);\n    border: 1px solid var(--line);\n    color: var(--text);\n    backdrop-filter: blur(18px);\n    -webkit-backdrop-filter: blur(18px);\n  }\n\n  .status-tint {\n    border: 1px solid var(--line);\n    background: rgba(255, 255, 255, 0.7);\n    color: var(--text);\n    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n  }\n\n  .dark .status-tint {\n    background: rgba(12, 22, 39, 0.76);\n  }\n\n  .gradient-badge {\n    background: var(--accent);\n    color: white;\n    box-shadow: var(--glow);\n  }\n\n  .gradient-badge-warm {\n    background: var(--accent-warm);\n    color: white;\n    box-shadow: 0 18px 44px rgba(249, 115, 22, 0.22);\n  }\n\n  .shimmer-card {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .shimmer-card::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(115deg, transparent 20%, rgba(255,255,255,0.28) 38%, transparent 56%);\n    transform: translateX(-120%);\n    animation: float-shimmer 2.2s ease-in-out infinite;\n  }\n\n  .skeleton-shimmer {\n    background:\n      linear-gradient(120deg, rgba(255,255,255,0.05) 20%, rgba(255,255,255,0.4) 40%, rgba(255,255,255,0.05) 60%),\n      rgba(148, 163, 184, 0.18);\n    background-size: 220% 100%;\n    animation: shimmer 1.5s linear infinite;\n  }\n\n  .leaflet-div-icon-reset {\n    background: transparent;\n    border: 0;\n  }\n\n  .leaflet-pin {\n    border-radius: 9999px;\n    border: 2px solid rgba(255,255,255,0.94);\n    box-shadow: 0 0 0 10px rgba(15, 23, 42, 0.08), 0 10px 26px rgba(15, 23, 42, 0.18);\n  }\n\n  .leaflet-pin-donor {\n    width: 18px;\n    height: 18px;\n    background: linear-gradient(135deg, #22c55e, #14b8a6);\n  }\n\n  .leaflet-pin-ngo {\n    width: 20px;\n    height: 20px;\n    background: linear-gradient(135deg, #0ea5e9, #38bdf8);\n    animation: pulse-marker 2s ease-in-out infinite;\n  }\n\n  .leaflet-pin-selected {\n    width: 22px;\n    height: 22px;\n    background: linear-gradient(135deg, #f97316, #fb7185);\n    animation: pulse-marker 1.8s ease-in-out infinite;\n  }\n\n  .leaflet-driver-marker {\n    position: relative;\n    width: 28px;\n    height: 28px;\n    border-radius: 9999px;\n    border: 2px solid rgba(255,255,255,0.96);\n    background: linear-gradient(135deg, #14b8a6, #38bdf8);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    font-weight: 800;\n    box-shadow:\n      0 0 0 10px rgba(20, 184, 166, 0.14),\n      0 12px 26px rgba(14, 165, 233, 0.22);\n  }\n\n  .leaflet-driver-marker::before {\n    content: '';\n    position: absolute;\n    inset: -7px;\n    border-radius: 9999px;\n    background: rgba(14, 165, 233, 0.18);\n    animation: pulse-marker 1.6s ease-in-out infinite;\n    z-index: -1;\n  }\n\n  .leaflet-container {\n    background: #dbeafe;\n    font-family: Inter, sans-serif;\n    border-radius: 28px;\n  }\n\n  .leaflet-popup-content-wrapper,\n  .leaflet-popup-tip {\n    background: rgba(255, 255, 255, 0.82);\n    color: #132238;\n    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);\n    backdrop-filter: blur(22px);\n    -webkit-backdrop-filter: blur(22px);\n  }\n\n  .dark .leaflet-popup-content-wrapper,\n  .dark .leaflet-popup-tip {\n    background: rgba(10, 18, 32, 0.88);\n    color: #f4f7fb;\n  }\n\n  .leaflet-control-zoom a {\n    color: #0f172a;\n    background: rgba(255, 255, 255, 0.96);\n  }\n\n  .dark .leaflet-control-zoom a {\n    color: #f8fafc;\n    background: rgba(10, 18, 32, 0.95);\n  }\n}\n\n@keyframes shimmer {\n  from {\n    background-position: 200% 0;\n  }\n\n  to {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes pulse-marker {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.96;\n  }\n\n  50% {\n    transform: scale(1.14);\n    opacity: 0.54;\n  }\n}\n\n@keyframes float-shimmer {\n  0% {\n    transform: translateX(-120%);\n  }\n\n  55%,\n  100% {\n    transform: translateX(140%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
